// Embedding Providers Registry

import { createTeiAdapter } from './tei.js'
import { createOllamaAdapter } from './ollama.js'
import { createTransformersAdapter } from './transformers.js'

export const providerFactories = {
  tei: createTeiAdapter,
  ollama: createOllamaAdapter,
  transformers: createTransformersAdapter,
}

export const availableProviders = ['tei', 'ollama', 'transformers']

export const defaultProvider = 'transformers'

/**
 * Create provider adapter
 * @param {string} providerName - Provider name
 * @param {Function} httpRequest - HTTP request function
 * @returns {Object} Provider adapter
 */
export const createProvider = (providerName, httpRequest) => {
  const factory = providerFactories[providerName]

  if (!factory) {
    throw new Error(
      `Unknown embedding provider: ${providerName}. Available: ${availableProviders.join(', ')}`
    )
  }

  return factory(httpRequest)
}
